module.exports = __webpack_public_path__ + "pc/img/main_work_img6.d28c8de3.jpg";